import { db } from '@/lib/firebase';
import { doc, getDoc } from 'firebase/firestore';
import { DEFAULT_INVOICEBUG_SETTINGS } from '../types/fieldSettings';

/**
 * Debug utility to check field visibility settings from GLOBAL collection
 * Can be called from browser console: window.debugFieldVisibility()
 */
export async function debugFieldVisibility() {
  console.log('🔍 Starting field visibility debug for GLOBAL settings');

  try {
    // Check if settings exist in GLOBAL collection
    const settingsDoc = await getDoc(
      doc(db, 'merchantApplicationSettings', 'config')
    );
    
    if (settingsDoc.exists()) {
      const data = settingsDoc.data();
      console.log('✅ Found settings in database:', data);
      
      // Check InvoiceBug settings
      const invoiceBugSettings = data.sources?.InvoiceBug;
      if (invoiceBugSettings) {
        console.log('📋 InvoiceBug settings:', invoiceBugSettings);
        
        // Check specific fields
        const cardPresentField = invoiceBugSettings.fieldSettings?.['processingHistory.cardPresentPercentage'];
        const ecommerceField = invoiceBugSettings.fieldSettings?.['processingHistory.ecommercePercentage'];
        
        console.log('💳 Card Present Percentage field:', cardPresentField);
        console.log('🛒 E-commerce Percentage field:', ecommerceField);
        
        console.log('Card Present enabled?', cardPresentField?.enabled);
        console.log('E-commerce enabled?', ecommerceField?.enabled);
      } else {
        console.log('❌ No InvoiceBug settings found in database');
      }
    } else {
      console.log('❌ No settings document found - should use defaults');
      console.log('📋 Default InvoiceBug settings:', DEFAULT_INVOICEBUG_SETTINGS);
      
      // Check default settings
      const cardPresentDefault = DEFAULT_INVOICEBUG_SETTINGS.fieldSettings['processingHistory.cardPresentPercentage'];
      const ecommerceDefault = DEFAULT_INVOICEBUG_SETTINGS.fieldSettings['processingHistory.ecommercePercentage'];
      
      console.log('💳 Default Card Present settings:', cardPresentDefault);
      console.log('🛒 Default E-commerce settings:', ecommerceDefault);
    }
    
  } catch (error) {
    console.error('❌ Error debugging field visibility:', error);
  }
}

// Export to window for easy access
if (typeof window !== 'undefined') {
  (window as any).debugFieldVisibility = debugFieldVisibility;
}